import React from "react";
import "./Education.scss";
import {educationInfo} from "../../portfolio";
import {Fade} from "react-reveal";

export default function Education() {
  if (!educationInfo.display) return null;

  return (
    <Fade bottom duration={800} distance="20px">
      <section className="education-section" id="education">
        <div className="editorial-heading">
          <span>04 / EDUCATION</span>
          <h2>Background</h2>
        </div>

        <div className="education-card-container">
          {educationInfo.schools.map((school, index) => (
            <article className="education-card" key={index}>
              <div className="education-year">{school.duration}</div>
              <div className="education-body">
                <div className="education-school-row">
                  {school.logo && (
                    <img
                      className="education-roundedimg"
                      src={school.logo}
                      alt={school.schoolName}
                    />
                  )}
                  <div>
                    <h3 className="education-text-school">{school.schoolName}</h3>
                    <p className="education-text-subHeader">{school.subHeader}</p>
                  </div>
                </div>

                <p className="education-text-desc">{school.desc}</p>

                {school.descBullets && (
                  <div className="education-tags">
                    {school.descBullets.map((item, i) => (
                      <span key={i}>{item}</span>
                    ))}
                  </div>
                )}
              </div>
            </article>
          ))}
        </div>
      </section>
    </Fade>
  );
}
